import React from 'react';
import { Link } from 'react-router-dom';

import AuthorList from 'rebook/apps/catalog/components/AuthorList';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const SearchAuthorList = ({ authorsList, authorsCount, query }) => (
  <div className={styles.section}>
    <div className="title-1">Авторы</div>
    {authorsCount > 3 && (
      <Link className="cy-search-all-authors"
        to={{
          pathname: `/search/authors/`,
          state: { authorsList, authorsCount, query },
          search: `?q=${query}` }}>
        <div className="link">
          {authorsCount} {pluralize(authorsCount, 'автор', 'автора', 'авторов')}
        </div>
      </Link>
    )}
    <div className={styles.content}>
      <AuthorList authors={authorsList.slice(0, 3)} />
    </div>
  </div>
);

export default SearchAuthorList;
